const sizeCategories = [
  { name: 'Small', value: 'Small', illustration: 'eli1n', unit: 'small' },
  { name: 'Medium', value: 'Medium', illustration: 'medium-package', unit: 'medium' },
  { name: 'Large', value: 'Large', illustration: 'large-package', unit: 'large' },
];

const weights = {
  small: [
    { name: '50 g', abbreviation: 'g', value: 50 },
    { name: '100 g', abbreviation: 'g', value: 100 },
    { name: '250 g', abbreviation: 'g', value: 250 },
    { name: '500 g', abbreviation: 'g', value: 500 },
    { name: '1 kg', abbreviation: 'kg', value: 1 },
    { name: '2 kg', abbreviation: 'kg', value: 2 },
  ],
  medium: [
    { name: '1 kg', abbreviation: 'kg', value: 1 },
    { name: '2 kg', abbreviation: 'kg', value: 2 },
    { name: '3 kg', abbreviation: 'kg', value: 3 },
    { name: '5 kg', abbreviation: 'kg', value: 5 },
    { name: '10 kg', abbreviation: 'kg', value: 10 },
    { name: '15 kg', abbreviation: 'kg', value: 15 },
    { name: '20 kg', abbreviation: 'kg', value: 20 },
  ],
  large: [
    { name: '3 kg', abbreviation: 'kg', value: 3 },
    { name: '5 kg', abbreviation: 'kg', value: 5 },
    { name: '10 kg', abbreviation: 'kg', value: 10 },
    { name: '15 kg', abbreviation: 'kg', value: 15 },
    { name: '20 kg', abbreviation: 'kg', value: 20 },
  ],
};

const RealValues = {
  WebUrl: 'https://riktigavykort.postnord.se/sv',
  AndroidAppUrl: 'https://play.google.com/store/apps/details?id=se.posten.riktigavykort&hl=sv',
  AndroidImg: 'https://com-inte.postnord.com/globalassets/icons/logos-and-badges/google-play-badge_se.svg',
  IosAppUrl: 'https://apps.apple.com/se/app/riktiga-vykort/id444458799?l=sv',
  IosImg: 'https://com-inte.postnord.com/globalassets/icons/logos-and-badges/app_store_badge_se_rgb_blk.svg',
};

const fileLocation = 'https://com-inte.postnord.com/globalassets/global/prices/sv-findprice-1-PN.xlsx';

const sendDirectUrl = 'https://portal.postnord.com/skickadirekt/';

const stampShopUrl = 'https://shop.postnord.se/ebutik/default.aspx';

const productDescriptionUrl = 'https://se-inte.postnord.com/skicka-forsandelser/brev-och-vykort/';

export { weights, sizeCategories, fileLocation, sendDirectUrl, stampShopUrl, RealValues };
